import { render, staticRenderFns } from "./EmissionTable.vue?vue&type=template&id=315a4f86&scoped=true"
import script from "./EmissionTable.vue?vue&type=script&lang=js"
export * from "./EmissionTable.vue?vue&type=script&lang=js"
import style0 from "./EmissionTable.vue?vue&type=style&index=0&id=315a4f86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315a4f86",
  null
  
)

export default component.exports